import { useEffect } from 'react'

const SmoothScroll = () => {
  useEffect(() => {
    // Smooth scroll for navigation links
    const handleSmoothScroll = (e) => {
      const href = e.target.getAttribute('href')
      
      if (href && href.startsWith('#')) {
        e.preventDefault()
        const targetId = href.substring(1)
        const targetElement = document.getElementById(targetId)
        
        if (targetElement) {
          targetElement.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          })
        }
      }
    }

    // Add event listeners to all navigation links
    const navLinks = document.querySelectorAll('a[href^="#"]')
    navLinks.forEach(link => {
      link.addEventListener('click', handleSmoothScroll)
    })

    // Cleanup event listeners
    return () => {
      navLinks.forEach(link => {
        link.removeEventListener('click', handleSmoothScroll)
      })
    }
  }, [])

  return null // This component doesn't render anything
}

export default SmoothScroll
